import a from"./getTranslate.js";import t from"./setTranslate.js";import r from"./minTranslate.js";import s from"./maxTranslate.js";import e from"./translateTo.js";const m={getTranslate:a,setTranslate:t,minTranslate:r,maxTranslate:s,translateTo:e};export{m as default};
//# sourceMappingURL=index.js.map
